import { CycleUtils } from '@wix/package-picker-shared';
import React from 'react';
import { useCurrentModule } from '../../ModuleProvider';
import { findAdjacentCycle } from './findAdjacentCycle';
import { SwitchToHigherCycle } from './SwitchToHigherCycle';
import { SwitchToLowerCycle } from './SwitchToLowerCycle';
export const ChangePlanCycle = _ref => {
  let {
    switchedViaBanner,
    onSwitchCycle
  } = _ref;
  const module = useCurrentModule();
  const selectedProductId = module.SDK.PackagePickerStore.useSelectedProductId();
  const selectedCycle = module.SDK.PackagePickerStore.useSelectedCycle();
  const {
    experiments
  } = module.internals.experiments.hooks.useExperiments();
  const isMultiYearUpsellEnabled = experiments.isEnabled('upgradeCycleUpsellCheckout');
  const {
    data: productPricing
  } = module.SDK.eclipseOfferingApiClient.hooks.useFetchProductPricing({
    productId: selectedProductId || ''
  }, Boolean(selectedProductId));
  const {
    data: offeringDiscount
  } = module.SDK.eclipseOfferingApiClient.hooks.useFetchOfferingDiscount({});
  const items = (productPricing == null ? void 0 : productPricing.cyclePricingItems) ?? [];
  const isMonthly = selectedCycle ? CycleUtils.isMonthly(selectedCycle) : false;
  const higherCycle = selectedCycle ? findAdjacentCycle(items, selectedCycle, 'higher') : undefined;
  const lowerCycle = selectedCycle ? findAdjacentCycle(items, selectedCycle, 'lower') : undefined;

  // The upsell is a non-sale-only treatment: while a sale is running the
  // summary already carries its own sale messaging, and we leave that flow
  // untouched. This deliberately reads the offering-level ("general") sale
  // rather than the selected product's own `hasSale`, so a plan that sits
  // outside the campaign — Light, typically — also stays untouched for the
  // duration of the sale instead of being treated as a non-sale plan.
  //
  // `hasSale` is always set on a settled response, so the strict `=== false`
  // doubles as the in-flight guard: while the query is pending we show nothing
  // rather than flashing the upsell and then pulling it once a sale resolves.
  const isNonSaleOffering = (offeringDiscount == null ? void 0 : offeringDiscount.hasSale) === false;
  const isTransitionEnabled = target => {
    const involvesMonthly = isMonthly || (target ? CycleUtils.isMonthly(target.cycle) : false);
    return isMultiYearUpsellEnabled && isNonSaleOffering && !involvesMonthly;
  };
  const showSwitchToHigherCycle = Boolean(higherCycle) && isTransitionEnabled(higherCycle) && !switchedViaBanner;
  const showSwitchToLowerCycle = switchedViaBanner && !isMonthly && Boolean(lowerCycle) && isTransitionEnabled(lowerCycle);
  if (showSwitchToHigherCycle && higherCycle) {
    return /*#__PURE__*/React.createElement(SwitchToHigherCycle, {
      targetPricing: higherCycle,
      items: items,
      onSwitchCycle: onSwitchCycle
    });
  }
  if (showSwitchToLowerCycle && lowerCycle) {
    return /*#__PURE__*/React.createElement(SwitchToLowerCycle, {
      targetPricing: lowerCycle,
      onSwitchCycle: onSwitchCycle
    });
  }
  return null;
};
//# sourceMappingURL=ChangePlanCycle.js.map